/* SmartBliss 2026: menu del telefono e scelta delle varianti nella pagina prodotto. */
(function () {
  const money = c => '€' + (c / 100).toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.');

  function initNav(root) {
    const btn = root.querySelector('[data-sb-burger]');
    const panel = btn && document.getElementById(btn.getAttribute('aria-controls'));
    if (!panel) return;
    const set = open => {
      btn.setAttribute('aria-expanded', open);
      btn.setAttribute('aria-label', open ? 'Chiudi il menu' : 'Apri il menu');
      panel.hidden = !open;
      document.documentElement.style.overflow = open ? 'hidden' : '';
    };
    btn.addEventListener('click', () => set(btn.getAttribute('aria-expanded') !== 'true'));

    // Su schermi stretti le voci non stanno nella barra: allora si usa il pulsante del menu.
    const bar = root.querySelector('.sb-nav__bar'), links = root.querySelector('.sb-nav__links');
    const logo = root.querySelector('.sb-nav__logo'), icons = root.querySelector('.sb-nav__icons');
    let needed = 0;
    const fit = () => {
      if (!links) return;
      if (!root.classList.contains('is-compact')) {
        const ul = links.firstElementChild, items = ul ? [...ul.children] : [];
        const gapUl = ul ? parseFloat(getComputedStyle(ul).columnGap) || 0 : 0;
        needed = items.reduce((w, li) => w + li.offsetWidth, 0) + gapUl * Math.max(0, items.length - 1);
        if (needed > links.clientWidth + 1) root.classList.add('is-compact');
      } else {
        const gap = parseFloat(getComputedStyle(bar).columnGap) || 20;
        const cs = getComputedStyle(bar);
        const free = bar.clientWidth - parseFloat(cs.paddingLeft) - parseFloat(cs.paddingRight) - logo.offsetWidth - icons.offsetWidth - gap * 2;
        if (needed && free >= needed + 8) {
          root.classList.remove('is-compact');
          if (!panel.hidden && matchMedia('(min-width: 901px)').matches) set(false);
          fit();
        }
      }
    };
    if (window.ResizeObserver) new ResizeObserver(fit).observe(bar); else addEventListener('resize', fit);
    if (document.fonts) document.fonts.ready.then(fit);
    fit();
    document.addEventListener('keydown', e => { if (e.key === 'Escape' && !panel.hidden) { set(false); btn.focus(); } });
  }

  function initPdp(root) {
    const variants = JSON.parse(root.querySelector('[data-sb-variants]').textContent);
    const img = root.querySelector('.sb-pdp__main img');
    const price = root.querySelector('[data-sb-price]'), stock = root.querySelector('[data-sb-stock]');
    const idInput = root.querySelector('[data-sb-id]'), add = root.querySelector('[data-sb-add]');
    const thumbs = [...root.querySelectorAll('[data-sb-thumb]')];

    const mainBox = root.querySelector('.sb-pdp__main');
    const colorOpt = parseInt(root.dataset.colorOpt, 10);
    const handle = s => String(s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
    // Mostra solo le foto del colore scelto; le foto senza colore (es. "tutti i colori") restano sempre.
    function filterByColor(value) {
      if (colorOpt < 0 || !thumbs.some(t => t.dataset.color)) return;
      const h = handle(value);
      thumbs.forEach(t => { t.hidden = !!t.dataset.color && t.dataset.color !== h; });
    }
    function show(src, mediaId) {
      if (!img || !src) return;
      const thumb = thumbs.find(t => t.dataset.sbThumb === String(mediaId));
      if (mainBox && thumb) mainBox.classList.toggle('is-wide', thumb.hasAttribute('data-wide'));
      thumbs.forEach(t => t.setAttribute('aria-pressed', t.dataset.sbThumb === String(mediaId)));
      if (img.getAttribute('src') === src) return;
      img.classList.add('is-fading');
      setTimeout(() => { img.removeAttribute('srcset'); img.src = src; img.classList.remove('is-fading'); }, 160);
    }
    thumbs.forEach(t => t.addEventListener('click', () => show(t.dataset.src, t.dataset.sbThumb)));

    const groups = [...new Set([...root.querySelectorAll('[data-sb-opt]')].map(i => i.dataset.sbOpt))];
    // Opzioni senza una variante disponibile con le altre scelte attuali: grigie, ma ancora selezionabili.
    function markAvailability(picked) {
      root.querySelectorAll('[data-sb-opt]').forEach(input => {
        const g = +input.dataset.sbOpt;
        const ok = variants.some(x => x.available && x.options.every((o, i) => i === g ? o === input.value : o === picked[i]));
        input.classList.toggle('is-na', !ok);
      });
    }
    function update() {
      const picked = groups.map(g => (root.querySelector(`[data-sb-opt="${g}"]:checked`) || {}).value);
      markAvailability(picked);
      const v = variants.find(x => x.options.every((o, i) => o === picked[i]));
      if (!v) {
        price.textContent = 'Combinazione non disponibile';
        stock.textContent = 'Scegli un\'altra opzione'; stock.classList.add('is-out');
        add.disabled = true; add.textContent = 'Non disponibile';
        return;
      }
      idInput.value = v.id;
      if (colorOpt >= 0) filterByColor(v.options[colorOpt]);
      if (v.price === 0) {
        price.textContent = 'Prezzo in negozio';
      } else {
        price.innerHTML = money(v.price) + (v.compare > v.price ? `<s>${money(v.compare)}</s><span class="sb-tag">Risparmi ${money(v.compare - v.price)}</span>` : '');
      }
      stock.textContent = v.available ? 'Disponibile · ritiro in giornata a Torino' : 'Esaurito online · chiedi in negozio';
      stock.classList.toggle('is-out', !v.available);
      add.disabled = !v.available || v.price === 0;
      add.textContent = v.price === 0 ? 'Prezzo in negozio' : v.available ? 'Aggiungi al carrello' : 'Esaurito';
      if (v.img) show(v.img, v.media);
      const url = new URL(location.href); url.searchParams.set('variant', v.id);
      history.replaceState(null, '', url);
    }
    root.addEventListener('change', e => { if (e.target.matches('[data-sb-opt]')) update(); });
    if (groups.length) markAvailability(groups.map(g => (root.querySelector(`[data-sb-opt="${g}"]:checked`) || {}).value));
    if (colorOpt >= 0) { const c = root.querySelector(`[data-sb-opt="${colorOpt}"]:checked`); if (c) filterByColor(c.value); }
  }

  function initColl(root) {
    const form = root.querySelector('[data-sb-filters]');
    if (!form) return;
    // Spunte e ordinamento si applicano subito; il prezzo con il suo pulsante.
    form.addEventListener('change', e => { if (e.target.matches('input[type=checkbox], select')) form.requestSubmit ? form.requestSubmit() : form.submit(); });
    form.addEventListener('submit', () => form.querySelectorAll('input[type=number]').forEach(i => { if (!i.value) i.disabled = true; }));
    const drops = [...root.querySelectorAll('.sb-drop')];
    drops.forEach(d => d.addEventListener('toggle', () => { if (d.open) drops.forEach(o => { if (o !== d) o.open = false; }); }));
    document.addEventListener('click', e => { if (!e.target.closest('.sb-drop')) drops.forEach(d => { d.open = false; }); });
    document.addEventListener('keydown', e => { if (e.key === 'Escape') drops.forEach(d => { d.open = false; }); });
  }

  function initCart(root) {
    const form = root.querySelector('#sb-cart-form');
    if (!form) return;
    root.classList.add('has-js');
    const update = form.querySelector('[data-sb-update]');
    const send = () => { root.classList.add('is-busy'); form.requestSubmit ? form.requestSubmit(update) : form.submit(); };
    form.addEventListener('click', e => {
      const b = e.target.closest('[data-sb-step]'); if (!b) return;
      const input = b.parentElement.querySelector('[data-sb-qty]');
      input.value = Math.max(0, (parseInt(input.value, 10) || 0) + +b.dataset.sbStep);
      send();
    });
    form.addEventListener('change', e => { if (e.target.matches('[data-sb-qty]')) send(); });
  }

  function boot(scope) {
    scope.querySelectorAll('[data-sb-nav]:not([data-sb-ready])').forEach(el => { el.dataset.sbReady = ''; initNav(el); });
    scope.querySelectorAll('[data-sb-pdp]:not([data-sb-ready])').forEach(el => { el.dataset.sbReady = ''; initPdp(el); });
    scope.querySelectorAll('[data-sb-coll]:not([data-sb-ready])').forEach(el => { el.dataset.sbReady = ''; initColl(el); });
    scope.querySelectorAll('[data-sb-cart]:not([data-sb-ready])').forEach(el => { el.dataset.sbReady = ''; initCart(el); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => boot(document)); else boot(document);
  document.addEventListener('shopify:section:load', e => boot(e.target));
})();
